import { axios } from '@Root/API'

export const create = payload => {
	return axios.post('attache/note/student-course-session', payload)
}
